import type { TNavigationPart } from "components/common/Breadcrumbs";
import type { TPageId } from "routes/route";

import constate from "constate";
import { Map as ImmutableMap } from "immutable";
import { useCallback, useState } from "react";

const usePage = () => {
  const [breadcrumbs, setBreadcrumbs] = useState<null | TNavigationPart[]>(null);
  const [pageLastState, setPageLastState] = useState(ImmutableMap<TPageId, Record<string, unknown>>());

  const setLastState = useCallback((pageId: TPageId, state?: Record<string, unknown>) => {
    setPageLastState((prevState) => (state ? prevState.set(pageId, state) : prevState.delete(pageId)));
  }, []);

  const updateLastState = useCallback((pageId: TPageId, state: Record<string, unknown>) => {
    setPageLastState((prevState) => prevState.set(pageId, { ...prevState.get(pageId), ...state }));
  }, []);

  return { actions: { setBreadcrumbs, setLastState, updateLastState }, state: { breadcrumbs, pageLastState } };
};

export const [PageProvider, usePageContext, useBreadcrumbs, usePageLastState] = constate(
  usePage,
  (value) => value,
  (value) => ({ breadcrumbs: value.state.breadcrumbs, setBreadcrumbs: value.actions.setBreadcrumbs }),
  (value) => ({
    pageLastState: value.state.pageLastState,
    setLastState: value.actions.setLastState,
    updateLastState: value.actions.updateLastState,
  }),
);
